<div class="modal-header">
    <h4 class="modal-title">{{data.companyName}} Anket Gönder</h4>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
        <div class="form-group">
            <label for="surveyId">Anket</label>
            <ng-select [items]="surveys" bindLabel="name" bindValue="id" formControlName="surveyId"></ng-select>
        </div>

        <div class="form-group">
            <label for="email">Mail</label>
            <input type="email" id="email" name="to" class="form-control" [(ngModel)]="data.mail" formControlName="mail"
                required email placeholder="example@mail.com" />

            <div *ngIf="form.get('mail').invalid && form.get('mail').touched" class="text-danger mt-1">
                <div *ngIf="form.get('mail').errors?.required">E-posta adresi zorunludur.</div>
                <div *ngIf="form.get('mail').errors?.email">Geçerli bir e-posta adresi giriniz.</div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer d-flex">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" (click)="surveyCustomerSend()"
        [disabled]="form.invalid">Gönder</button>
</div>